// src/common.ts
var BillingProductCode = /* @__PURE__ */ ((BillingProductCode2) => {
  BillingProductCode2["WarrantySales"] = "WRRNT_SALES";
  BillingProductCode2["HardBundleSales"] = "HARDBUN_SALES";
  return BillingProductCode2;
})(BillingProductCode || {});
var ProductType = /* @__PURE__ */ ((ProductType2) => {
  ProductType2["Mobility"] = "MOBILITY";
  ProductType2["ConnectedHome"] = "CONNECTEDHOME";
  return ProductType2;
})(ProductType || {});
var SupportedPartners = /* @__PURE__ */ ((SupportedPartners2) => {
  SupportedPartners2["ASURION"] = "Asurion";
  SupportedPartners2["ATT"] = "ATT";
  SupportedPartners2["CLARO_BRAZIL"] = "Claro Brazil";
  SupportedPartners2["VERIZON"] = "Verizon";
  return SupportedPartners2;
})(SupportedPartners || {});
var QueryParams = /* @__PURE__ */ ((QueryParams2) => {
  QueryParams2["ReferrerCode"] = "RCO";
  QueryParams2["AgentId"] = "a_id";
  QueryParams2["SalesSessionId"] = "ss_id";
  QueryParams2["StoreCode"] = "s_c";
  QueryParams2["DealerCode"] = "d_c";
  QueryParams2["DealerName"] = "d_n";
  QueryParams2["VendorData"] = "v_data";
  QueryParams2["CampaignId"] = "cid";
  QueryParams2["AccountId"] = "accountId";
  QueryParams2["Partner"] = "partner";
  QueryParams2["PromoCode"] = "p_c";
  QueryParams2["SourceApp"] = "sourceApp";
  QueryParams2["SalesChannel"] = "sales_channel";
  QueryParams2["CouponCode"] = "c_c";
  QueryParams2["UtmSource"] = "utm_source";
  QueryParams2["UtmCampaign"] = "utm_campaign";
  QueryParams2["UtmMedium"] = "utm_medium";
  QueryParams2["UtmTerm"] = "utm_term";
  QueryParams2["UtmContent"] = "utm_content";
  QueryParams2["UtmCarrier"] = "utm_carrier";
  QueryParams2["BillId"] = "billId";
  QueryParams2["ProductSku"] = "product_sku";
  return QueryParams2;
})(QueryParams || {});
var countryCodeUS = "1";
var CLIENT_CHANNEL_ID_MAP = /* @__PURE__ */ new Map([
  ["ATTHTP", "C10D49A78FF26637E0539B39030AA612"],
  ["HOMEPLUS1000", "8A725682288C1B27E0538A1F080A66D6"],
  ["HOMEPLUSENT", "8A725682288C1B27E0538A1F080A66D6"],
  ["APPLHOMEPLUS30", "8A725682288C1B27E0538A1F080A66D6"],
  ["APPHOMEPLUSANNUAL360", "8A725682288C1B27E0538A1F080A66D6"],
  ["APPLHOMEPLUS35_99", "8A725682288C1B27E0538A1F080A66D6"],
  ["CRICKETHOMEPLUS", "8A725682288C1B27E0538A1F080A66D6"],
  ["3002", "95352E742A092CE6E0538A1F080A777C"]
]);
var PRODUCT_SKU_CONFIG_MAP = /* @__PURE__ */ new Map([
  [
    "HOMEPLUS1000",
    {
      planName: "Asurion Home+",
      price: "24.99",
      billingProgramId: "AHP-ASURIONSALESPORTAL-AGENT-US",
      productType: "CONNECTEDHOME" /* ConnectedHome */,
      billingProductCode: "WRRNT_SALES" /* WarrantySales */
    }
  ],
  [
    "HOMEPLUSENT",
    {
      planName: "Asurion Home Entertainment",
      price: "14.99",
      billingProgramId: "AHP-ASURIONSALESPORTAL-AGENT-US",
      productType: "CONNECTEDHOME" /* ConnectedHome */,
      billingProductCode: "WRRNT_SALES" /* WarrantySales */
    }
  ],
  [
    "APPLHOMEPLUS30",
    {
      planName: "Appliance+",
      price: "29.99",
      billingProgramId: "APPLIANCEPLUS-ASURIONSALESPORTAL-AGENT-US",
      productType: "CONNECTEDHOME" /* ConnectedHome */,
      billingProductCode: "WRRNT_SALES" /* WarrantySales */
    }
  ],
  [
    "APPHOMEPLUSANNUAL360",
    {
      planName: "Appliance+",
      price: "29.99",
      billingProgramId: "APPLIANCEPLUS-ASURIONSALESPORTAL-AGENT-US",
      productType: "CONNECTEDHOME" /* ConnectedHome */,
      billingProductCode: "WRRNT_SALES" /* WarrantySales */
    }
  ],
  [
    "APPLHOMEPLUS35_99",
    {
      planName: "Appliance+",
      price: "34.99",
      billingProgramId: "APPLIANCEPLUS-ASURIONSALESPORTAL-AGENT-US",
      productType: "CONNECTEDHOME" /* ConnectedHome */,
      billingProductCode: "WRRNT_SALES" /* WarrantySales */
    }
  ],
  [
    "CRICKETHOMEPLUS",
    {
      planName: "Asurion Home+",
      price: "24.99",
      billingProgramId: "CRICKETHOMEPLUS-ASURIONSALESPORTAL-AGENT-US",
      productType: "CONNECTEDHOME" /* ConnectedHome */,
      billingProductCode: "WRRNT_SALES" /* WarrantySales */
    }
  ]
]);
var BILLING_PROGRAM_ID_TXN_COMMENT_2_MAP = /* @__PURE__ */ new Map([
  ["AHP-ASURIONSALESPORTAL-AGENT-US", "ASP|WEB|en-US|Retail|Asurion HomePlus"],
  [
    "CRICKETHOMEPLUS-ASURIONSALESPORTAL-AGENT-US",
    "ASP|WEB|en-US|Retail|Asurion HomePlus"
  ],
  [
    "APPLIANCEPLUS-ASURIONSALESPORTAL-AGENT-US",
    "ASP|WEB|en-US|Retail|Appliance Plus"
  ],
  ["1500194", "ASP|WEB|en-US|Retail|Asurion Mobility"]
]);

// src/customer-api.ts
var CUSTOMER_API_CLIENT_CHANNEL_IDS_MAP = /* @__PURE__ */ new Map([
  ["Asurion_Complete_MyHome", "85043B8BF2B134A3E0539B39030A721E"],
  ["Asurion_Homeplus", "8A725682288C1B27E0538A1F080A66D6"],
  ["Cricket", "416E2FA388E2164AE0539B39030ACB29"],
  ["ATT_Protect_Home", "C10D49A78FF26637E0539B39030AA612"]
]);
var AgreementStatus = /* @__PURE__ */ ((AgreementStatus2) => {
  AgreementStatus2["Active"] = "ACTV";
  AgreementStatus2["Terminated"] = "TRMNTD";
  AgreementStatus2["Suspended"] = "SUSPND";
  return AgreementStatus2;
})(AgreementStatus || {});
var ExtensionCode = /* @__PURE__ */ ((ExtensionCode2) => {
  ExtensionCode2[ExtensionCode2["FLOOR_NUMBER"] = 0] = "FLOOR_NUMBER";
  return ExtensionCode2;
})(ExtensionCode || {});
var ContactPointTypeInput = /* @__PURE__ */ ((ContactPointTypeInput2) => {
  ContactPointTypeInput2["PHONE"] = "PHONE";
  ContactPointTypeInput2["EMAIL"] = "EMAIL";
  ContactPointTypeInput2["MOBILE"] = "MOBILE";
  return ContactPointTypeInput2;
})(ContactPointTypeInput || {});

// src/customer-session.ts
var SessionStatus = /* @__PURE__ */ ((SessionStatus2) => {
  SessionStatus2["Callback"] = "CALLBACK";
  SessionStatus2["Completed"] = "COMPLETED";
  SessionStatus2["InProgress"] = "IN_PROGRESS";
  SessionStatus2["HasEligibleOffers"] = "HAS_ELIGIBLE_OFFERS";
  SessionStatus2["NoEligibleOffers"] = "NO_ELIGIBLE_OFFERS";
  SessionStatus2["StartedWithMDN"] = "STARTED_WITH_MDN";
  SessionStatus2["StartedWithoutMDN"] = "STARTED_WITHOUT_MDN";
  SessionStatus2["ClosedByRefresh"] = "CLOSED_BY_REFRESH";
  return SessionStatus2;
})(SessionStatus || {});
var CustomerSessionAddressType = /* @__PURE__ */ ((CustomerSessionAddressType2) => {
  CustomerSessionAddressType2["Billing"] = "BILLING";
  CustomerSessionAddressType2["Service"] = "SERVICE";
  return CustomerSessionAddressType2;
})(CustomerSessionAddressType || {});

// src/product-offer.ts
var ProductOfferStatus = /* @__PURE__ */ ((ProductOfferStatus2) => {
  ProductOfferStatus2["NOT_OFFERED"] = "NOT_OFFERED";
  ProductOfferStatus2["OFFERED"] = "OFFERED";
  ProductOfferStatus2["ACCEPTED"] = "ACCEPTED";
  ProductOfferStatus2["DECLINED"] = "DECLINED";
  return ProductOfferStatus2;
})(ProductOfferStatus || {});
var ProductEligibilityStatus = /* @__PURE__ */ ((ProductEligibilityStatus2) => {
  ProductEligibilityStatus2["INITIALIZED"] = "INITIALIZED";
  ProductEligibilityStatus2["ELIGIBLE"] = "ELIGIBLE";
  ProductEligibilityStatus2["INELIGIBLE"] = "INELIGIBLE";
  ProductEligibilityStatus2["ALREADY_ENROLLED"] = "ALREADY_ENROLLED";
  ProductEligibilityStatus2["PENDING_ENROLLMENT"] = "PENDING_ENROLLMENT";
  ProductEligibilityStatus2["PENDING"] = "PENDING";
  ProductEligibilityStatus2["ERROR"] = "ERROR";
  ProductEligibilityStatus2["UPGRADEABLE"] = "UPGRADEABLE";
  ProductEligibilityStatus2["EXTERNAL"] = "EXTERNAL";
  return ProductEligibilityStatus2;
})(ProductEligibilityStatus || {});
var ProductEnrollmentErrorCategory = /* @__PURE__ */ ((ProductEnrollmentErrorCategory2) => {
  ProductEnrollmentErrorCategory2["ALREADY_ENROLLED"] = "ALREADY_ENROLLED";
  ProductEnrollmentErrorCategory2["BILLING"] = "BILLING";
  ProductEnrollmentErrorCategory2["INELIGIBLE"] = "INELIGIBLE";
  ProductEnrollmentErrorCategory2["GENERIC"] = "GENERIC";
  return ProductEnrollmentErrorCategory2;
})(ProductEnrollmentErrorCategory || {});
var ProductEnrollmentStatus = /* @__PURE__ */ ((ProductEnrollmentStatus2) => {
  ProductEnrollmentStatus2["PENDING"] = "PENDING";
  ProductEnrollmentStatus2["INITIALIZED"] = "INITIALIZED";
  ProductEnrollmentStatus2["SUCCESS"] = "SUCCESS";
  ProductEnrollmentStatus2["FAILURE"] = "FAILURE";
  return ProductEnrollmentStatus2;
})(ProductEnrollmentStatus || {});

// src/server-actions.ts
var ServerActionErrorCode = /* @__PURE__ */ ((ServerActionErrorCode2) => {
  ServerActionErrorCode2["BaseError"] = "BaseError";
  ServerActionErrorCode2["BillingGatewayTokenNotFound"] = "BillingGatewayTokenNotFound";
  ServerActionErrorCode2["DuplicateError"] = "DuplicateError";
  ServerActionErrorCode2["FormValidationError"] = "FormValidationError";
  ServerActionErrorCode2["InvalidError"] = "InvalidError";
  ServerActionErrorCode2["MaxAttemptsError"] = "MaxAttemptsError";
  ServerActionErrorCode2["NotFoundError"] = "NotFoundError";
  ServerActionErrorCode2["NotVerifiedError"] = "NotVerifiedError";
  ServerActionErrorCode2["IneligibleError"] = "IneligibleError";
  ServerActionErrorCode2["RecaptchaTokenNotFound"] = "RecaptchaTokenNotFound";
  ServerActionErrorCode2["RecaptchaNotVerified"] = "RecaptchaNotVerified";
  ServerActionErrorCode2["UnknownError"] = "UnknownError";
  return ServerActionErrorCode2;
})(ServerActionErrorCode || {});
export {
  AgreementStatus,
  BILLING_PROGRAM_ID_TXN_COMMENT_2_MAP,
  BillingProductCode,
  CLIENT_CHANNEL_ID_MAP,
  CUSTOMER_API_CLIENT_CHANNEL_IDS_MAP,
  ContactPointTypeInput,
  CustomerSessionAddressType,
  ExtensionCode,
  PRODUCT_SKU_CONFIG_MAP,
  ProductEligibilityStatus,
  ProductEnrollmentErrorCategory,
  ProductEnrollmentStatus,
  ProductOfferStatus,
  ProductType,
  QueryParams,
  ServerActionErrorCode,
  SessionStatus,
  SupportedPartners,
  countryCodeUS
};
